<template>
  <div>
    <HeroSection />
    <ServicesSection />
    <AppsSection />
    <WorkSection />
    <StandardsSection />
    <ProcessSection />
    <AboutSection />
    <FaqSection />
    <ContactSection />
  </div>
</template>

<script>
import HeroSection from '@/sections/HeroSection.vue'
import ServicesSection from '@/sections/ServicesSection.vue'
import AppsSection from '@/sections/AppsSection.vue'
import WorkSection from '@/sections/WorkSection.vue'
import StandardsSection from '@/sections/StandardsSection.vue'
import ProcessSection from '@/sections/ProcessSection.vue'
import AboutSection from '@/sections/AboutSection.vue'
import FaqSection from '@/sections/FaqSection.vue'
import ContactSection from '@/sections/ContactSection.vue'

export default {
  name: 'HomeView',
  components: {
    HeroSection,
    ServicesSection,
    AppsSection,
    WorkSection,
    StandardsSection,
    ProcessSection,
    AboutSection,
    FaqSection,
    ContactSection,
  },
}
</script>
